// extracted by mini-css-extract-plugin
export default {"title":"VerifyEmailModal_title__+M5NN","text":"VerifyEmailModal_text__14TbV","dashboardModalBody":"VerifyEmailModal_dashboardModalBody__LK2K8"};